import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBmpToJpgConfig } from '@/data/landingConfig/landingBmpToJpgConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BmpToJpg } from './schemaObject';

interface Props {}
const BmpToJpgConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BmpToJpg} />
			<LandingTemplate
				data={landingBmpToJpgConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default BmpToJpgConverter;
